import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
    faTimes,
    faChevronLeft,
    faChevronRight as faChevronRightSolid,
    faSearchPlus,
} from "@fortawesome/free-solid-svg-icons";


export default function Sewout() {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const portfolioImages = [
        { id: 1, src: '/images/portfolio/embriodery1.png', alt: 'Embroidery Design 1' },
        { id: 2, src: '/images/portfolio/embriodery2.png', alt: 'Embroidery Design 2' },
        { id: 3, src: '/images/portfolio/embriodery3.png', alt: 'Embroidery Design 3' },
        { id: 4, src: '/images/portfolio/embriodery4.png', alt: 'Embroidery Design 4' },
        { id: 5, src: '/images/portfolio/embriodery5.png', alt: 'Embroidery Design 5' },
        { id: 6, src: '/images/portfolio/embriodery6.png', alt: 'Embroidery Design 6' },
        { id: 7, src: '/images/portfolio/embriodery7.png', alt: 'Embroidery Design 7' },
        { id: 8, src: '/images/portfolio/embriodery8.png', alt: 'Embroidery Design 8' },
        { id: 9, src: '/images/portfolio/embriodery9.png', alt: 'Embroidery Design 9' },
    ];

    const openLightbox = (index) => {
        setCurrentImageIndex(index);
        setLightboxOpen(true);
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
        document.body.style.overflow = 'auto';
    };

    const goToNext = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === portfolioImages.length - 1 ? 0 : prevIndex + 1
        );
    };

    const goToPrevious = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? portfolioImages.length - 1 : prevIndex - 1
        );
    };

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (!lightboxOpen) return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowRight') goToNext();
            if (e.key === 'ArrowLeft') goToPrevious();
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [lightboxOpen]);

    return (
        <>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Sewout</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Sewout</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/applique1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Texture. Depth. Creative Impact.</span>
                                <h3 className="case-study-title">Accurate Sew-Outs for Perfect Production</h3>
                                <p className="case-study-description">
                                    Our sew-out service allows you to see your design come to life before full-scale production begins. By stitching out your digitized file on fabric, we help identify any issues in thread density, stitch direction, or overall appearance. This ensures that your design translates perfectly from screen to fabric with no surprises.
                                </p>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we focus on precision and quality in every sew-out. Our team carefully tests each design to make sure it meets industry standards and your expectations. This step is essential for achieving clean, professional embroidery results while avoiding costly errors during bulk production.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Structured for Seamless Fabric Application</span>
                                <h3 className="case-study-title">Quality Testing That Builds Confidence</h3>
                                <p className="case-study-description">
                                    Sew-outs are a crucial step for brands and businesses that value consistency and detail. Whether you’re working on logos, patches, or custom apparel, our testing process ensures that every stitch is optimized for the fabric and machine being used. This guarantees a polished final product every time.
                                </p>
                                <p className="case-study-description">
                                    By choosing our sew-out service, you gain complete confidence in your designs before moving forward. We provide clear feedback and make necessary adjustments to improve the outcome, helping you save time, reduce waste, and deliver high-quality embroidered products to your customers.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/applique2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section className="portfolio-main-section gallery-section">
                <div className="container">
                    <div className="portfolio-grid">
                        {portfolioImages.map((image, index) => (
                            <div
                                key={image.id}
                                className="portfolio-grid-item"
                                onClick={() => openLightbox(index)}
                            >
                                <div className="portfolio-image-wrapper">
                                    <img
                                        src={image.src}
                                        alt={image.alt}
                                        className="portfolio-image"
                                    />
                                    <div className="portfolio-overlay">
                                        <div className="portfolio-zoom-icon">
                                            <FontAwesomeIcon icon={faSearchPlus} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {lightboxOpen && (
                <div className="portfolio-lightbox" onClick={closeLightbox}>
                    <button className="lightbox-close" onClick={closeLightbox}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>

                    <button className="lightbox-prev" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>

                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <img
                            src={portfolioImages[currentImageIndex].src}
                            alt={portfolioImages[currentImageIndex].alt}
                            className="lightbox-image"
                        />
                        <div className="lightbox-counter">
                            {currentImageIndex + 1} / {portfolioImages.length}
                        </div>
                    </div>

                    <button className="lightbox-next" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
                        <FontAwesomeIcon icon={faChevronRightSolid} />
                    </button>
                </div>
            )}

            <Newsletter />

            <Footer />
        </>
    )
}
